<template>
  <section class="records-section">
    <h2 class="section-title">参与记录</h2>

    <div class="record-block">
      <h3 class="record-label">当前参与地址</h3>
      <ul class="record-list">
        <li v-if="loading" class="empty-item">加载中...</li>
        <li v-else-if="currentParticipants.length === 0" class="empty-item">
          暂无参与者
        </li>
        <li v-for="(address, index) in currentParticipants" :key="`current-${index}`">
          {{ index + 1 }}:{{ address }}
        </li>
      </ul>
    </div>

    <div class="record-block">
      <h3 class="record-label">历史中奖记录</h3>
      <ul class="record-list">
        <li v-if="loading" class="empty-item">加载中...</li>
        <li v-else-if="historyWinners.length === 0" class="empty-item">
          暂无中奖记录
        </li>
        <li v-for="(address, index) in historyWinners" :key="`history-${index}`">
          {{ index + 1 }}:{{ address }}
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    currentParticipants: {
      type: Array,
      default: () => [],
    },
    historyWinners: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.records-section {
  padding: 0 30px 40px;
}

.section-title {
  margin: 0 0 20px;
  font-size: 30px;
  color: #fff;
}

.record-block {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.record-label {
  margin: 0 0 12px;
  font-size: 28px;
  color: #fff;
}

.record-list {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    margin-bottom: 10px;
    font-size: 26px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.75);
    word-break: break-all;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .empty-item {
    color: rgba(255, 255, 255, 0.45);
  }
}
</style>
